<div class="current-user primary-nav__current-user">
	<div>		
		<p style="color:red" *ngIf="instance!='PROD'">{{instance}} Instance</p>
	</div>
  	<div class="current-user__item">
  		Welcome, <strong class="current-user__name">{{username}}</strong>
  	</div>
  	<div class="current-user__item">
		<a routerLink="practitioner/profile/edit" class="current-user__link">Edit Profile</a>
	</div>
	<div class="current-user__item current-user__title" *ngIf="isCredentialed">
		Credentialed Practitioner <i class="icon icon--check-circle"></i>
	</div>
	<div class="current-user__item current-user__cart" *ngIf="isCredentialed">
		<a routerLink="purchase/checkout" class="current-user__link current-user__link--cart">
			<span  class="cart-item-indicator">{{itemCount}}</span>
			<span class="icon icon--shopping-cart"></span>
			<span>Cart</span>
		</a>
	</div>
</div>